module.exports = __webpack_public_path__ + "media/images/icn-close-0b9c691628482ccf8b20d1f4938d0d1f.png";